import _ from 'lodash';
import env from '../../env';
import { AppClientId } from '../Shared/constants';
import dayjs from 'dayjs';

export const TRANSPORT_ORDER_DOMAIN = 'app/modules/Contents/TRANSPORT_ORDER_DOMAIN';

export const REQUEST_TRANSPORT_ORDER_CREATE = 'app/modules/Contents/REQUEST_TRANSPORT_ORDER_CREATE';
export const REQUEST_TRANSPORT_ORDER_EDIT = 'app/modules/Contents/REQUEST_TRANSPORT_ORDER_EDIT';
export const REQUEST_DELETE_TRANSPORT_ORDER = 'app/modules/Contents/REQUEST_DELETE_TRANSPORT_ORDER';
export const REQUEST_TRANSPORT_ORDERS = 'app/modules/Contents/REQUEST_TRANSPORT_ORDERS';
export const REQUEST_TRANSPORT_ORDER = 'app/modules/Contents/REQUEST_TRANSPORT_ORDER';
export const REQUEST_VEHICLE_TRANSPORT_ORDERS = 'app/modules/Contents/REQUEST_VEHICLE_TRANSPORT_ORDERS';
export const INITIATE_TRANSPORT_ORDER_CREATE = 'app/modules/Contents/INITIATE_TRANSPORT_ORDER_CREATE';
export const INITIATE_TRANSPORT_ORDER_EDIT = 'app/modules/Contents/INITIATE_TRANSPORT_ORDER_EDIT';
export const SET_NEW_TRANSPORT_ORDER_VALUE = 'app/modules/Contents/SET_NEW_TRANSPORT_ORDER_VALUE';
export const DELETE_TRANSPORT_ORDER_TRANSPORTER = 'app/modules/Contents/DELETE_TRANSPORT_ORDER_TRANSPORTER';
export const DELETE_TRANSPORT_ORDER_PROPERTY = 'app/modules/Contents/DELETE_TRANSPORT_ORDER_PROPERTY';

export const REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE = 'app/modules/Contents/REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE';

export const FILTER_DEFAULT_LIMIT = 50;

export const REQUEST_TRANSPORT_ORDER_FILTER = 'app/modules/Contents/REQUEST_TRANSPORT_ORDER_FILTER';
export const APPLY_TRANSPORT_ORDER_FILTERS = 'app/modules/Contents/APPLY_TRANSPORT_ORDER_FILTERS';
export const SET_TRANSPORT_ORDERS_SORT = 'app/modules/Contents/SET_TRANSPORT_ORDERS_SORT';
export const REQUEST_TRANSPORT_ORDER_FILTER_RESET = 'app/modules/Contents/REQUEST_TRANSPORT_ORDER_FILTER_RESET';
export const UPDATE_TRANSPORT_ORDER_FILTERS = 'app/modules/Contents/UPDATE_TRANSPORT_ORDER_FILTERS';
export const UPDATE_TRANSPORT_ORDER_SEARCH_STRING = 'app/modules/Contents/UPDATE_TRANSPORT_ORDER_SEARCH_STRING';
export const SET_FILTER_COMBINATION = 'app/modules/Contents/SET_FILTER_COMBINATION';

export const REQUEST_UPDATE_SELECTED_TRANSPORT_ORDERS = 'app/modules/Contents/REQUEST_UPDATE_SELECTED_TRANSPORT_ORDERS';
export const REQUEST_CREATE_TRANSPORT_ORDER_BULK_ACTION = 'app/modules/Contents/REQUEST_CREATE_TRANSPORT_ORDER_BULK_ACTION';
export const ADD_TRANSPORT_ORDER_TO_BULK_ACTIONS_LIST = 'app/modules/Contents/ADD_TRANSPORT_ORDER_TO_BULK_ACTIONS_LIST';
export const REMOVE_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST =
  'app/modules/Contents/REMOVE_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST';
export const REMOVE_ALL_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST =
  'app/modules/Contents/REMOVE_ALL_TRANSPORT_ORDER_FROM_BULK_ACTIONS_LIST';

// Split, double screen view
export const APPLY_TRANSPORT_ORDER_FILTERS_SEPARATE_LIST =
  'app/modules/Contents/APPLY_TRANSPORT_ORDER_FILTERS_SEPARATE_LIST';

export const SWITCH_OVERVIEW_SCREEN_MODE = 'app/modules/Contents/SWITCH_OVERVIEW_SCREEN_MODE';

export const TRANSPORT_ORDER_COLUMN_1_FIELD_TYPES = [
  'status',

  'type',
  'vehicleId',
  // 'transporter',
  'remarks',
  //'scheduledDate',
  'transporterId',
  'dateToPlan',
];

export const TRANSPORT_ORDER_COLUMN_1_PLAN_TYPES = ['transporterId', 'datePlanned', 'remarks'];

export const TRANSPORT_ORDER_COLUMN_1_ADD_TYPES = [
  //'status',
  'type',
  'vehicleId',
  //'transporterId',
  // 'transporter',
  'remarks',
  // 'scheduledDate',
  // 'datePlanned',
  'dateToPlan',
];

export const TRANSPORT_ORDER_COLUMN_2_FIELD_TYPES = ['companyFromId', 'addressFromId', 'companyToId', 'addressToId'];

export const TRANSPORT_ORDER_TYPE = ['incoming', 'outgoing', 'other'];
export const TRANSPORT_ORDER_STATUS_OPTIONS = ['requested', 'initiated', 'done', 'canceled'];
export const TRANSPORT_ORDER_STATUS = {
  Requested: 'requested',
  Initiated: 'initiated',
  Done: 'done',
  Canceled: 'canceled',
};

const TODAYS_DATE = dayjs(Date.now()).format('DD-MM-YYYY');

export const QUICK_FILTER = {
  IncomingAndRequested: {
    combination: '1',
    filter: [
      {
        key: 'type',
        value: ['incoming'],
        label: ['Inkomend'],
        type: 'single',
      },
      {
        key: 'countryFrom',
        value: [156],
        label: ['Nederland'],
        type: 'multiple',
      },
      {
        key: 'status',
        value: ['requested'],
        label: ['Aangevraagd'],
        type: 'single',
      },
      { key: 'dateToPlan', value: [null, TODAYS_DATE], label: [], type: 'ranged_date' },
    ],
  },
  OutgoingAndRequested: {
    combination: '2',
    filter: [
      {
        key: 'status',
        value: ['requested'],
        label: ['Aangevraagd'],
        type: 'single',
      },
      {
        key: 'type',
        value: ['outgoing'],
        label: ['Uitgaand'],
        type: 'single',
      },
      {
        key: 'countryTo',
        value: [156],
        label: ['Nederland'],
        type: 'multiple',
      },
      { key: 'outgoing_invoice_finalized', value: ['1'], label: ['Finalized'], type: 'multiple' },
    ],
  },
  NotNLOutgoingRequested: {
    combination: '3',
    filter: [
      {
        key: 'countryTo',
        value: ['156'],
        label: ['Niet - NL'],
        type: 'multiple',
        inversed: true,
      },
      {
        key: 'status',
        value: ['requested'],
        label: ['Aangevraagd'],
        type: 'multiple',
      },
      {
        key: 'type',
        value: ['outgoing'],
        label: ['Uitgaand'],
        type: 'multiple',
      },
    ],
  },
  NotNLIncomingRequested: {
    combination: '4',
    filter: [
      {
        key: 'countryFrom',
        value: ['156'],
        label: ['Niet - NL'],
        type: 'multiple',
        inversed: true,
      },
      {
        key: 'status',
        value: ['requested'],
        label: ['Aanvraagd'],
        type: 'multiple',
      },
      {
        key: 'type',
        value: ['incoming'],
        label: ['Inkomend'],
        type: 'multiple',
      },
    ],
  },
  PlannedJohn: {
    combination: '5',
    filter: [
      {
        key: 'status',
        value: ['initiated'],
        label: ['Gepland'],
        type: 'multiple',
      },
      {
        key: 'transporterId',
        value: ['1'],
        label: ['John'],
        type: 'multiple',
      },
    ],
  },
  PlannedAlwin: {
    combination: '6',
    filter: [
      {
        key: 'status',
        value: ['initiated'],
        label: ['Gepland'],
        type: 'multiple',
      },
      {
        key: 'transporterId',
        value: ['2'],
        label: ['Alwin'],
        type: 'multiple',
      },
    ],
  },

  PlannedIntern: {
    combination: '9',
    filter: [
      {
        key: 'status',
        value: ['initiated'],
        label: ['Gepland'],
        type: 'multiple',
      },
      {
        key: 'transporterId',
        value: ['6'],
        label: ['Intern'],
        type: 'multiple',
      },
    ],
  },

  PlannedMatthijs: {
    combination: '7',
    filter: [
      {
        key: 'status',
        value: ['initiated'],
        label: ['Gepland'],
        type: 'multiple',
      },
      {
        key: 'transporterId',
        value: ['3'],
        label: ['Matthijs'],
        type: 'multiple',
      },
    ],
  },

  PlannedDirk: {
    combination: '8',
    filter: [
      {
        key: 'status',
        value: ['initiated'],
        label: ['Gepland'],
        type: 'multiple',
      },
      {
        key: 'transporterId',
        value: ['4'],
        label: ['Dick'],
        type: 'multiple',
      },
    ],
  },
};
